import React, { useEffect, useRef } from 'react';
import { ICheckoutResult } from '../../backend/types/responses';

interface IProps {
  checkout: ICheckoutResult;
}

export const HiddenSubmitForm: React.FC<IProps> = props => {
  const { checkout } = props;
  const {
    customer: { billingAddress },
  } = checkout;
  const formRef = useRef(null);

  useEffect(() => {
    formRef.current.submit();
  }, []);

  /*
  all possible (?) fields are listed here
  http://support.worldpay.com/support/kb/bg/htmlredirect/Content/rhtml/Integrating_your_website_with.htm
  */

  /*
  more documentation
  http://support.worldpay.com/support/kb/bg/htmlredirect/Content/rhtml/HTML_Redirect_parameters.htm
  */

  return (
    <form ref={formRef} method="POST" action={checkout.redirectUrl}>
      <input type="hidden" name="testMode" value={checkout.mode} />
      <input type="hidden" name="instId" value={checkout.installationId} />
      <input type="hidden" name="cartId" value={checkout.referenceId} />
      <input type="hidden" name="amount" value={checkout.price.amount} />
      <input type="hidden" name="currency" value={checkout.price.currency} />

      <input
        type="hidden"
        name="name"
        value={billingAddress.firstName + ' ' + billingAddress.lastName}
      />
      <input type="hidden" name="address1" value={billingAddress.address1} />
      <input type="hidden" name="address2" value={billingAddress.address2} />
      <input type="hidden" name="address3" value={billingAddress.address3} />

      <input type="hidden" name="tel" value={billingAddress.phoneNumber} />

      <input type="hidden" name="town" value={billingAddress.city} />
      <input type="hidden" name="region" value={billingAddress.state} />
      <input type="hidden" name="postcode" value={billingAddress.postalCode} />
      <input type="hidden" name="country" value={billingAddress.countryCode} />

      <input type="hidden" name="email" value={checkout.customer.email} />

      <input type="hidden" name="fixContact" />
      <input type="hidden" name="hideContact" />
      {/* <input type="hidden" name="hideCurrency" /> */}
    </form>
  );
};
